import api from '../api';

import { ParamsBodyPostObterDadosCorretorPorPedido, ParamsDataPostObterDadosCorretorPorPedido } from 'utils/typeServices';

export const PostObterDadosCorretorPorPedido = async ({ body }: { body: ParamsBodyPostObterDadosCorretorPorPedido }) => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await api.post<{ Data: ParamsDataPostObterDadosCorretorPorPedido }>(`/v1/Plataforma/GetBrokerData?nrPlataforma=${body.NR_PLATAFORMA}`, {}, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        });

        return data.Data;
    } catch (error) {
        console.error('error', error);
        return null;
    }
}
